/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var cleanUpResponse = require('common/util/cleanUpResponse');

module.exports = function(data) {
  var defer = $.Deferred();

  $.soap({
    body: {
      GetLicenseContactByContactType: {
        $xmlns: 'http://dobs.pa.gov/nd/license/bpm/1.0',
        LicenseID: data.licenseId,
        LicenseContactTypeID: data.licenseContactTypeId
      }
    },
    blueprintArrays: ['GetLicenseContactByContactTypeResponse.Contacts.ND_LicenseContact'],
    blueprint: {
      contacts: [
        '$..ND_LicenseContact',
        {
          id: '$..ID',
          firstName: '$..FirstName',
          lastName: '$..LastName',
          title: '$..Title',
          homePhoneNumber: '$..HomePhoneNumber',
          cellPhoneNumber: '$..CellPhoneNumber',
          email: '$..Email',
          isDeleted: '$..IsDeleted',
          licenseId: '$..LicenseID',
          licenseContactTypeId: '$..LicenseContactTypeID',
          addressId: '$..AddressID',
          createdDate: '$..CreatedDate',
          createdBy: '$..CreatedBy',
          modifiedDate: '$..ModifiedDate',
          modifiedBy: '$..ModifiedBy',
          address: {
            addressLine1: '$..AddressLine1',
            addressLine2: '$..AddressLine2',
            addressLine3: '$..AddressLine3',
            county: '$..County',
            city: '$..City',
            state: '$..State',
            postalCode: '$..PostalCode',
            country: '$..Country'
          }
        }
      ]
    }
  })
    .done(function(response) {
      cleanUpResponse(response);

      defer.resolve(response.contacts);
    })
    .fail(function(err) {
      defer.reject(err);
    });

  return defer.promise();
};
